import { useState, useEffect } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import * as API from "../services/API";
import "../css/QsnAdmin.css";
import Footer from "../components/Footer";
import ErrorModal from "../components/ErrorModal";
import SuccessToast from "../components/SuccessToast";
// Composant affichage public
function PublicQsn({ blocks }) {
  const safeBlocks = Array.isArray(blocks) ? blocks : [];

  if (safeBlocks.length === 0)
    return (
      <div className="text-center text-muted py-5">
        Aucun contenu disponible
      </div>
    );

  return (
    <div className="container py-5">
      {safeBlocks.map((block) => (
        <div
  key={block.id}
  className="mb-5 p-4 rounded-4 shadow-sm"
  style={{ backgroundColor: "#FFFFFF" }}
>
  {/* TITRE */}
  <div
    className="mb-3 px-4 py-2 text-dark"
    style={{
      fontWeight: 700,
      borderRadius: "0.5rem",
      fontSize: "2rem",
      display: "inline-block",
    }}
  >
    {block.title || "Titre du bloc"}
  </div>

  {/* IMAGE + TEXTE */}
  <div
    className={`d-flex align-items-start mt-2 py-3 flex-column flex-md-row ${
      block.position === "right" ? "flex-md-row-reverse" : ""
    }`}
  >
    {block.image ? (
      <img
        src={block.image}
        alt=""
        className="rounded-4 shadow-sm"
        style={{ width: 300, height: "auto", objectFit: "cover" }}
      />
    ) : (<></>
      // <div
      //   style={{
      //     width: 240,
      //     height: 240,
      //     backgroundColor: "#E5E7EB",
      //     display: "flex",
      //     justifyContent: "center",
      //     alignItems: "center",
      //     borderRadius: "1rem",
      //     color: "#6B7280",
      //     fontWeight: 600,
      //     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      //   }}
      // >
      //   Image
      // </div>
    )}

    <div className="mt-3 mt-md-0 px-md-4" style={{ flex: 1 }}>
      <p
        className="mb-0"
        style={{ color: "#4B5563", lineHeight: 1.6, fontSize: "1.4rem" }}
      >
        {block.text || "Lorem ipsum dolor sit amet, consectetur adipiscing elit."}
      </p>
    </div>
  </div>
</div>
      ))}
    </div>
  );
}



// Composant édition des blocs
function QsnEditor({ blocks, setBlocks, onCancel, onValidate,setSavedBlocks }) {
  const addBlock = () => {
    setBlocks([
      ...blocks,
      {
        id: Date.now(),
        title: "",
        text: "",
        image: null,
        position: "left",
        extension: "",
      },
    ]);
  };

const updateBlock = (id, field, value) => {
  setBlocks(prevBlocks =>
    prevBlocks.map(block =>
      block.id === id ? { ...block, [field]: value } : block
    )
  );
};

  const removeBlockRequest = (id) => {
    API.removeQsnRequest({_id:id},()=>{API.getAllQsnRequest((qsn)=>{setBlocks(qsn.data);setSavedBlocks(qsn.data);},()=>{})},()=>{});
  };
   const removeBlock = (id) => {
    setBlocks(blocks.filter((block) => block.id !== id));
  };

  return (
    <div className="container py-5">
      {blocks.map((block, index) => (
        <div
          key={block.id}
          className="card border-0 shadow-sm rounded-4 mb-4"
        >
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <strong style={{ color: "#2563EB" }}>Bloc #{index + 1}</strong>
              <span className="badge bg-light border text-dark">
                Image à {block.position === "left" ? "gauche" : "droite"}
              </span>
            </div>

            <div className="row g-4">
              {/* Édition */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Titre</label>
                <input
                  className="form-control mb-3"
                  placeholder="Titre du bloc"
                  value={block.title}
                  onChange={(e) =>
                    updateBlock(block.id, "title", e.target.value)
                  }
                />

                <label className="form-label fw-semibold">Texte</label>
                <textarea
                  className="form-control mb-3"
                  rows="4"
                  placeholder="Contenu du texte"
                  value={block.text}
                  onChange={(e) =>
                    updateBlock(block.id, "text", e.target.value)
                  }
                />

                <label className="form-label fw-semibold">Image</label>
                <input
                  type="file"
                  className="form-control mb-3"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    updateBlock(block.id, "extension", e.target.files[0].type.replace("image/",""));
                    if (!file) return;

                    const reader = new FileReader();
                    reader.onloadend = () => {
                      updateBlock(block.id, "image", reader.result);
                    };
                    reader.readAsDataURL(file);
                  }}
                />

                <label className="form-label fw-semibold">Position de l’image</label>
                <select
                  className="form-select mb-3"
                  value={block.position}
                  onChange={(e) =>
                    updateBlock(block.id, "position", e.target.value)
                  }
                >
                  <option value="left">À gauche</option>
                  <option value="right">À droite</option>
                </select>

                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => {block._id?removeBlockRequest(block._id):removeBlock(block.id)}}
                >
                  Supprimer le bloc
                </button>
              </div>

              {/* Preview */}
              <div className="col-md-6">
                <div
                  className="p-3 rounded-3 h-100"
                  style={{ backgroundColor: "#F9FAFB" }}
                >
                  <small className="text-muted fw-semibold">
                    Aperçu du rendu
                  </small>

                  <div
                    className={`d-flex align-items-center mt-3 ${
                      block.position === "right" ? "flex-row-reverse" : ""
                    }`}
                  >
                    <div
                      className="rounded-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 120,
                        height: 120,
                        backgroundColor: "#E5E7EB",
                        color: "#6B7280",
                        fontWeight: 600,
                        flexShrink: 0,
                      }}
                    >
                      Image
                    </div>

                    <div className="px-3">
                      <h5 className="fw-bold mb-2">
                        {block.title || "Titre du bloc"}
                      </h5>
                      <p className="text-muted mb-0">
                        {block.text || "Texte du bloc"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Actions */}
      <div className="d-flex justify-content-between align-items-center mt-4">
        <button className="btn btn-outline-primary fw-semibold" onClick={addBlock}>
          + Ajouter un bloc
        </button>

        <div className="d-flex gap-2">
          <button className="btn btn-primary px-4" onClick={onValidate}>
            Valider
          </button>
          <button className="btn btn-light border" onClick={onCancel}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}

// Composant principal
function QsnAdmin() {
  const [savedBlocks, setSavedBlocks] = useState([]);
  const [draftBlocks, setDraftBlocks] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Charger les blocs depuis le backend
  useEffect(() => {

    API.getAllQsnRequest(
      (qsn) => {
        setSavedBlocks(qsn.data);
      },
      () => {}
    );
  }, []);

  // Passer en mode édition
  const handleEdit = () => {
    setDraftBlocks(savedBlocks);
    setIsEditing(true);
  };

  // Valider les modifications
  const handleValidate = () => {
    API.CreateQsnRequest(
      draftBlocks,
      () => {
        API.getAllQsnRequest(
          (qsn) => {
            setSavedBlocks(qsn.data);
            setDraftBlocks([]);
            setIsEditing(false);
            setSuccess("Contenu enregistre avec succes.");
          },
          () => {}
        );
      },
      (err) => setError(err)
    );
  };

  // Annuler les modifications
  const handleCancel = () => {
    setDraftBlocks([]);
    setIsEditing(false);
  };

  return (
    <>
    <div className="min-vh-100" style={{ backgroundColor: "#F4F6F8" }}>
      <HeaderHomeAdmin />

      {/* Bouton modifier */}
      {!isEditing && (
        <div className="container py-5">
          <button className="btn btn-outline-primary mb-4" onClick={handleEdit}>
            Modifier la page
          </button>
        </div>
      )}
      
      <h1 className="text-center mb-4 text-dark">
          Qui sommes-nous?
        </h1>

      {/* Affichage public */}
      {!isEditing && <PublicQsn blocks={savedBlocks} />}

      {/* Édition */}
      {isEditing && (
        <QsnEditor
          blocks={draftBlocks}
          setBlocks={setDraftBlocks}
          onValidate={handleValidate}
          onCancel={handleCancel}
          setSavedBlocks={setSavedBlocks}
        />
      )}
    </div>
    <ErrorModal
      show={!!error}
      message={error}
      onClose={() => setError(null)}
    />
    <SuccessToast
      show={!!success}
      message={success}
      onClose={() => setSuccess(null)}
    />
    <Footer/>
    </>
  );
}

export default QsnAdmin;
